import React from "react";
import { Container, Typography, Paper, Box, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

function Info() {
  return (
    <Container component="main" maxWidth="lg">
      <Box
        sx={{
          marginTop: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: "100%" }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Trikotversteigerung des EHC Kundl – Ersteigert die Original-Weihnachtsjerseys!
          </Typography>

          <Typography paragraph sx={{ mt: 3 }}>
            Liebe Fans des EHC Kundl,
          </Typography>

          <Typography paragraph>
            unsere Mannschaft bestreitet die aktuellen Spiele in der Vorweihnachtszeit in Weihnachtstrikots. Diese Trikots werden hier in Form einer Versteigerung angeboten.
          </Typography>

          <Typography paragraph>
            Sucht euch euren Lieblingsspieler aus und steigert das originalgetragene Trikot im Weihnachtslook.
          </Typography>

          <Box sx={{ my: 3 }}>
            <Typography variant="h5" gutterBottom color="secondary">
              So funktioniert die Auktion:
            </Typography>
            <Box component="ul" sx={{ pl: 2 }}>
              <Typography component="li">
                <strong>Auktion nur online:</strong> Eine Gebotsabgabe vor Ort ist nicht möglich.
              </Typography>
              <Typography component="li">
                <strong>Startgebot:</strong> Jedes Trikot startet bei 60 Euro.
              </Typography>
              <Typography component="li">
                <strong>Gebotserhöhung:</strong> Mindestens 5 € (höhere Gebote möglich)
              </Typography>
              <Typography component="li">
                <strong>Ende der Versteigerung:</strong> 20.12.2025, 23:00 Uhr
              </Typography>
              <Typography component="li">
                <strong>Soft-Close:</strong> Wird innerhalb der letzten 3 Minuten ein Gebot abgegeben, verlängert sich die Auktion für dieses Trikot automatisch um 3 Minuten.
              </Typography>
              <Typography component="li">
                Erst wenn innerhalb dieser Verlängerung kein Gebot mehr eingeht, endet die Auktion.
              </Typography>
            </Box>
          </Box>

          <Box sx={{ my: 3 }}>
            <Typography variant="h5" gutterBottom color="secondary">
              Weitere Details:
            </Typography>
            <Box component="ul" sx={{ pl: 2 }}>
              <Typography component="li">
                <strong>Mehrere Trikots:</strong> Eine Person kann mehrere Trikots ersteigern.
              </Typography>
              <Typography component="li">
                <strong>Zahlung:</strong> Bar vor Ort.
              </Typography>
              <Typography component="li">
                <strong>Jersey-Übergabe:</strong> Die Jerseys werden nach dem Ende der Auktion übergeben
              </Typography>
              <Typography component="li">
                <strong>Datenschutz:</strong> Alle erhobenen Daten werden ausschließlich für die Durchführung der Auktion genutzt und direkt im Anschluss gelöscht.
              </Typography>
              <Typography component="li">
                <strong>Rechtsweg:</strong> Der Rechtsweg ist ausgeschlossen.
              </Typography>
            </Box>
          </Box>

          <Box sx={{ mt: 4, textAlign: "center" }}>
            <Typography paragraph>
              Viel Erfolg beim Bieten!
            </Typography>
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        <img
            src="/EHC_logo.svg"
            alt="EHC Kundl Logo"
            style={{
                height: "50px",
                width: "auto"
            }}
        />
    </Box>
    <Button
        sx={{
            mt: 2
        }}
        color="secondary"
        component={RouterLink}
        to="/"
        variant="contained"
    >
        Zurück zum Dashboard
    </Button>
</Box>
        </Paper>
      </Box>
    </Container>
  );
}

export default Info;
